import { render, staticRenderFns } from "./crearRemision.vue?vue&type=template&id=78b02a40"
import script from "./crearRemision.vue?vue&type=script&lang=js"
export * from "./crearRemision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports